import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import userReducer from "./slices/userSlice";
import authReducer from "./slices/authSlice";
import emmsAuthReducer from "./slices/emmsAuthSlice";
import emmsReducer from "./slices/emmsSlice";
import currEmmsReducer from "./slices/currentEmmsSlice";
import locationReducer from "./slices/locationSlice";
import allMeetingSpacesReducer from "./slices/allMeetingSpacesSlice";
import customisationReducer from "./slices/customisationSlice";
import screenuserReducer from "./slices/screenusersSlice";
import licenseReducer from "./slices/licenseSlice";
import calendarReducer from "./slices/calendarSlice";
import activeComponentReducer from "./slices/activeComponent";
import apikeyReducer from "./slices/apikeySlice";
import stagedDeviceReducer from "./slices/stagedDeviceSlice";
import deviceReducer from "./slices/deviceSlice";
import currApikeyReducer from "./slices/currentApikeySelectedSlice";
import capabilitiesReducer from "./slices/capabilitiesSlice";
import globalConfigReducer from "./slices/globalconfigurations.slice";
import globalconfigurationsSlice from "./slices/globalconfigurations.slice";
import templateReducer from "./slices/templateSlice";
import eventcustomisationReducer from "./slices/eventcustomisationsSlice";
import playlistReducer from "./slices/playlistSlice";
import Preview from "./slices/Preview";
import Time from "./slices/Time";
import meetingReducer from "./slices/meetingSlice";
import scheduleSelectionReducer from "./slices/scheduleSectionSlice";
import FallbackContent from "./slices/FallBackContent";
import LinkMeetings from "./slices/LinkMeetings";
import layoutReducer from "./slices/layoutSlice";
import dataToDisplayReducer from "./slices/dataToDisplay";
import selectedLayoutReducer from "./slices/selectedLayoutSlice";
import templateValuesReducer from "./slices/templateValuesSlice";
import resolutionReducer from "./slices/resolutionSlice";
import selectedContentAIReducer from "./slices/selectedContentAI";
import dmzReducer from "./slices/dmzSlice";
import maxLimitReducer from "./slices/maxLimitSlice";
import eventcustomisationglobalupdateReducer from "./slices/eventCustomisationGlobalUpdateSlice";
import emmScreenuserIdsReducer from "./slices/emmScreenuserSlice";
import groupsReducer from "./slices/groupsSlice";
import truInkReducer from "./slices/truInk"
import reportingReducer from "./slices/reportingSlice"

// Combine all reducers
const rootReducer = combineReducers({
  user: userReducer,
  header: authReducer,
  emmsheader: emmsAuthReducer,
  emms: emmsReducer,
  curremms: currEmmsReducer,
  location: locationReducer,
  allmeetingspaces: allMeetingSpacesReducer,
  customisations: customisationReducer,
  screenusers: screenuserReducer,
  license: licenseReducer,
  calendar: calendarReducer,
  activeComponent: activeComponentReducer,
  apikey: apikeyReducer,
  stagedDevice: stagedDeviceReducer,
  device: deviceReducer,
  currapikey: currApikeyReducer,
  capabilitiesOptions: capabilitiesReducer,
  globalconfigurations: globalConfigReducer,
  template: templateReducer,
  eventcustomisations: eventcustomisationReducer,
  playlist: playlistReducer,
  preview: Preview,
  time: Time,
  meeting: meetingReducer,
  schedule: scheduleSelectionReducer,
  fallbackContent: FallbackContent,
  linkedmeetings: LinkMeetings,
  layout: layoutReducer,
  dataToDisplay: dataToDisplayReducer,
  selectedLayout: selectedLayoutReducer,
  templateValues: templateValuesReducer,
  resolution: resolutionReducer,
  selectedContentAI: selectedContentAIReducer,
  dmz: dmzReducer,
  maxLimit: maxLimitReducer,
  eventcustomisationglobalupdate: eventcustomisationglobalupdateReducer,
  emmConfig: emmScreenuserIdsReducer,
  groups: groupsReducer,
  truInk: truInkReducer,
  reporting: reportingReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['truInk']
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST, persist/REHYDRATE']
      },
    }),
});

export const persistor = persistStore(store);

